import React from 'react';
import { Card, Icon, Popup, Segment } from "semantic-ui-react";
import { HoverControls, HTMLPreview, ControlledPopup, USER_PERMISSIONS, PRODUCT_PERMISSIONS } from "dyl-components";

import './index.scss';
import RestrictedView from 'dyl-components/molecules/Restricted';

const Template = ({
    previewContent,
    name,
    onPreview,
    onEdit,
    onCopy,
    onDelete,
    type,
}) => (
    <Segment className='Template' basic>
        <Card
            className='Template__preview'
            image={(
                <HoverControls
                    controls={(
                        <div className="Template__controls">
                            <Icon onClick={onPreview} name='eye' link />
                            <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.LIBRARY_EDIT}><Icon onClick={onEdit} name='pencil' link /></RestrictedView>
                            <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.LIBRARY_EDIT} productPermission={type === "email" ? PRODUCT_PERMISSIONS.SETTINGS_EMAIL_TEMPLATES : PRODUCT_PERMISSIONS.SETTINGS_TEXT_TEMPLATES}><Icon onClick={onCopy} name='fas fa-copy' link /></RestrictedView>
                            <RestrictedView type='controlledPopupDisabled' userPermission={USER_PERMISSIONS.LIBRARY_DELETE}>
                            <ControlledPopup
                                trigger={<Icon name='fas fa-trash' link />}
                                onConfirm={onDelete}
                            />
                            </RestrictedView>
                        </div>
                    )}
                >
                    <HTMLPreview
                        content={previewContent}
                    />
                </HoverControls>
            )}
        />
        <div className='Template__favorite'>
            <h5>
                <Popup
                    trigger={
                        <span>{name}</span>
                    }
                    inverted
                    position='top center'
                    content={name}
                    basic
                />
            </h5>
        </div>
    </Segment>
);

export default Template;
